import React from "react";
import { Play, ExternalLink } from "lucide-react";
import { toStreamEmbed } from "@/lib/defcon";

// Renders an inline 16:9 stream player (YouTube/Twitch/Kick/direct video) when
// the URL is embeddable; otherwise falls back to a "Watch Live" link-out button.
export default function StreamPlayer({ url, color = "#FF3B30", className = "" }) {
  if (!url) return null;
  const embed = toStreamEmbed(url, typeof window !== "undefined" ? window.location.hostname : "");

  if (!embed) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className={`inline-flex items-center justify-center gap-2 px-6 py-3.5 font-mono-ui text-xs uppercase tracking-[0.18em] text-white hover:brightness-110 transition-all ${className}`}
        style={{ background: color }}
        data-testid="stream-watch-link"
      >
        <Play size={15} /> Watch Live <ExternalLink size={13} />
      </a>
    );
  }

  return (
    <div className={`w-full ${className}`} data-testid="stream-embed">
      <div className="relative w-full border border-[var(--ff-border)]" style={{ paddingTop: "56.25%" }}>
        {embed.type === "file" ? (
          <video src={embed.src} controls autoPlay muted playsInline className="absolute inset-0 w-full h-full bg-black" />
        ) : (
          <iframe
            src={embed.src}
            title="Live stream"
            className="absolute inset-0 w-full h-full bg-black"
            frameBorder="0"
            allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
            allowFullScreen
            data-testid="stream-iframe"
          />
        )}
      </div>
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center gap-1 mt-2 font-mono-ui text-[0.6rem] uppercase tracking-[0.15em] text-[var(--ff-text-dim)] hover:text-white"
        data-testid="stream-open-external"
      >
        Open in new tab <ExternalLink size={11} />
      </a>
    </div>
  );
}
